import * as React from 'react';
import * as _ from 'lodash';
import CheckBox from './../PageLayout/CheckBox';
export default function () {
    function onClick1(item, itemIndex) {
        this.handleSelectItem(item);
    }
    function onChecked2(item, itemIndex) {
        this.handleSelectItem(item);
    }
    function repeatItem3(item, itemIndex) {
        return [
            !this.props.multiple ? React.createElement('div', {
                'className': 'radio-list-item ' + (item.selected ? 'selected' : ''),
                'onClick': onClick1.bind(this, item, itemIndex),
                'key': '1161'
            }, '\r\n      ', item.text, '\r\n    ') : null,
            this.props.multiple ? React.createElement(CheckBox, {
                'checked': item.selected,
                'onChecked': onChecked2.bind(this, item, itemIndex),
                'type': 'tiny',
                'text': item.text,
                'key': '1163'
            }) : null
        ];
    }
    return React.createElement.apply(this, [
        'div',
        { 'className': 'radio-list-container' },
        _.map(this.state.items, repeatItem3.bind(this))
    ]);
}